var _a;
/**
 * @hidden
 */
export var nodata = 'dropdowns.nodata';
/**
 * @hidden
 */
export var clear = 'dropdowns.clear';
/**
 * @hidden
 */
export var messages = (_a = {},
    _a[clear] = 'clear',
    _a[nodata] = 'NO DATA FOUND.',
    _a);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-dropdowns/dist/es/messages/index.js
// module id = 516
// module chunks = 0